import React from 'react';
import Button from 'components/Button';
import ModalCustom from 'components/Modal';

type TModalParentCompanyProps = {
  modalParentDialog: boolean;
  setModalParentDialog: any;
  handleSubmitForm: () => void;
};

export const ModalParentCompany: React.FC<TModalParentCompanyProps> = ({
  modalParentDialog,
  setModalParentDialog,
  handleSubmitForm,
}) => {
  const handleClose = () => {
    setModalParentDialog(false);
  };

  const handleSubmit = () => {
    handleSubmitForm();
    setModalParentDialog(false);
  };

  return (
    <ModalCustom
      title={
        'Are you sure you want to make this a Parent Company with Branch Locations?'
      }
      open={modalParentDialog}
      subTittle={
        'Updating this will remove this company from the existing Parent Company and update all analytics.'
      }
      handleClose={handleClose}
      groupButton={
        <>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '20px',
              border: '1px solid #213B54',
              width: '97px',
              height: '40px',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '20px',
              width: '97px',
              height: '40px',
            }}
          >
            Save
          </Button>
        </>
      }
    />
  );
};
